import requests from '@/utils/request.js'

export const getHeaderTabMenu = () => requests({
  method:'POST',
  url:'/api/user/data/topmenu',
})

export const getAsideTabMenu = (pid) => requests({
  method:'POST',
  url:'/api/user/data/leftmenu',
  params:{
    pid
  }
})